<div class="refound-type-box" [class.is-disabled]="!editable" [class.is-selected]="selected"
  [style.backgroundColor]="selected ? expenseClassificationColor : '#fbfcfd'"
  [style.borderColor]="prefillColor"
  (click)="this.editable ? this.onClicked.emit(this.item) : null" [ngClass]="expenseClassificationEnum[this.item]">
  <div class="refound-type-logo">
    <svg-icon fontSize="50px" [key]="expenseClassificationKey"></svg-icon>
  </div>
  <div class="refound-type-detail">{{newLabel[this.item] ?? (('ExpenseClassification_' +
    expenseClassificationEnum[this.item]) |
    NTSTranslate)}}
  </div>
</div>
